<template lang="html">

  <div class="candidaturas-view -directorio">

    <h2>{{$t('header.directorio')}}</h2>

    <h3>{{$t('directorio.bannerInfo')}}</h3>
    
    <div class="btn-not-container">
      <router-link class="btn -skull-primary"  :to="$t('enlaces.directorio')">{{$t('acceder')}}</router-link>
    </div>

  </div>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import router from '@/router';
  
  export default  {
    name: 'modulo-orientacion-solicitar',
    components : {
    },
    mounted(){
      
    },
    data(){
      return {
      }
    },
    methods: {
      ...mapActions([
      ]),
      navegarUrlSolicitar: function(){
        router.push('/orientacion/solicitar-orientacion/');
      }
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
      }),
    },
  }
</script>

<style scoped lang="scss">

  .candidaturas-view.-directorio{
    width: 100%;
    background-image: url("/static/img/img-stock-directorio.png");
    background-position: center center;
    padding: 155px 0;
    background-size: cover;
    margin: 90px 0 40px 0;

  }

  h2{
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    color: white;
  }

  h3{
    margin: 30px 500px;
    color: white;
  }
    
  @media screen and (max-width: 1667px){
    h3{
      margin: 30px 300px;
    }
  }

  @media screen and (max-width: 1167px){
    h3{
      margin: 30px 150px;
    }
  }

  @media screen and (max-width: 767px){
    h3{
      margin: 30px 50px;
    }
  }


  @media screen and (max-width: 380px){
    h3{
      margin: 30px 10px;
    }
  }

  .-btn-not-container{
  }

  .-skull-primary{
    color: white;
    border: 2px solid white !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-directorio-solicitar.vue